import React from 'react';
import { useIntl } from 'umi';
import MemoryIcon from '@/pages/aigc/assets/svg/agent-memory-icon.svg';
import './index.scss';

interface IMemoryEntryProps {
  onOpen: () => void;
}

const MemoryEntry: React.FC<IMemoryEntryProps> = ({ onOpen }) => {
  const { formatMessage, locale } = useIntl();

  return (
    <div className="dba-memory-entry-wrap">
      <button
        type="button"
        className="dba-memory-entry"
        data-locale={locale}
        aria-label={formatMessage({ id: 'dba_memory_management' })}
        onClick={onOpen}
      >
        <img
          className="dba-memory-entry__icon"
          src={MemoryIcon}
          alt=""
          aria-hidden
        />
        <span className="dba-memory-entry__text">
          {formatMessage({ id: 'dba_memory_management' })}
        </span>
      </button>
    </div>
  );
};

export default MemoryEntry;
